import { refreshAccessRightsAsync, signInAsync } from "./AuthReducer";
import { put, takeLatest } from "redux-saga/effects";
import { getAuthCurrentUserAccessRights, postAuthSignIn } from "Api/Api";
import { getType } from "typesafe-actions";
import { call } from "typed-redux-saga";
import Cookies from "universal-cookie";

function* signIn(action: ReturnType<typeof signInAsync.request>): Generator {
  try {
    const response = yield* call(postAuthSignIn, action.payload);
    if (response.status === 200) {
      localStorage.setItem("jwtToken", `Bearer ${response.json.token}`);
      new Cookies().set(
        process.env.REACT_APP_IBIS_TOKEN_NAME ?? "",
        `Bearer ${response.json.token}`,
        {
          path: "/",
          domain: process.env.REACT_APP_DOMAIN,
          expires: new Date(new Date().getFullYear() + 5, 1, 1),
        },
      );
      yield put(signInAsync.success(response.json));
    } else {
      yield put(signInAsync.failure(new Error(response.json.errorMessage)));
    }
  } catch (err) {
    yield put(signInAsync.failure(err));
  }
}
export function* signInSaga() {
  yield takeLatest(getType(signInAsync.request), signIn);
}

function* refreshAccessRights(
  action: ReturnType<typeof refreshAccessRightsAsync.request>,
): Generator {
  try {
    const response = yield* call(getAuthCurrentUserAccessRights);
    if (response.status === 200) {
      yield put(refreshAccessRightsAsync.success(response.json));
    }
  } catch (err) {
    yield put(refreshAccessRightsAsync.failure(err));
  }
}
export function* refreshAccessRightsSaga() {
  yield takeLatest(
    getType(refreshAccessRightsAsync.request),
    refreshAccessRights,
  );
}
